import React from "react";
import { Box } from "@twilio-paste/core";
import { useTheme } from "@twilio-paste/theme";
import { Button } from "@twilio-paste/button";

type Props = {
  isLoading: boolean;
  hasLoadError: boolean;
  onReload: () => void;
};

const ConversationLoadingState: React.FC<Props> = ({
  isLoading,
  hasLoadError,
  onReload,
}) => {
  const theme = useTheme();

  return (
    <Box
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        rowGap: theme.space.space50,
        color: theme.textColors.colorTextWeak,
      }}
    >
      {isLoading && !hasLoadError && <>Collegamento a Twilio in corso...</>}

      {!isLoading && hasLoadError && (
        <>
          <Box>Non è stato possibile caricare la conversazione.</Box>
          <Button variant="primary" onClick={onReload}>
            Ricarica conversazione
          </Button>
        </>
      )}

      {!isLoading && !hasLoadError && <>Nessuna conversazione caricata.</>}
    </Box>
  );
};

export default ConversationLoadingState;
